import {
  Divider,
  IconButton,
  InputAdornment,
  LinearProgress,
  Typography,
  withStyles
} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import RefreshIcon from '@material-ui/icons/Refresh'
import { Checkbox, Snackbar } from 'elentari'
import React, { useState } from 'react'
import { Field } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'
import { useParams } from 'react-router-dom'
import { CustomAutocomplete } from '../../../components'
import { CustomTextField } from '../../../components/CustomDisabledFields'
import CustomFileViewer from '../../../components/CustomFileViewer'
import DropzoneField from '../../../components/DropzoneField'
import NumberFormatCustom from '../../../components/NumberFormatCustom'
import ObservacaoField from '../../../components/ObservacaoField'
import Select from '../../../components/Select'
import TextField from '../../../components/TextField'
import UploadField from '../../../components/UploadField'
import { parseCpf, parsePlaca } from '../../../utils/Parse'
import { validateCpfOrCnpj, validatePlaca } from '../../../utils/Validators'
import MercadoriaAutocomplete from '../../Mercadorias/MercadoriaAutocomplete'
import { estadosOptions } from '../../Municipio/estados'
import MunicipioAutocomplete from '../../Municipio/MunicipioAutocomplete'
import solicitacoesEmbarcadorRepository from '../../SolicitacoesEmbarcador/solicitacoesEmbarcadorRepository'

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  marginTop: {
    marginTop: theme.spacing(5)
  }
})

const customTrim = str => {
  if (str) {
    return str.toString().trim()
  }
  return ''
}

export const validateInformacoes = informacoes => ({
  cpfRenovacao: informacoes.renovado
    ? validateCpfOrCnpj(informacoes.cpfRenovacao)
    : undefined,
  placaRenovacao: informacoes.renovado
    ? validatePlaca(informacoes.placaRenovacao)
      ? undefined
      : 'Obrigatório'
    : undefined,
  gr: customTrim(informacoes.gr) ? undefined : 'Obrigatório',
  contratoAgregadoInput:
    informacoes.gr === 'AGREGADO'
      ? customTrim(informacoes.contratoAgregadoInput)
        ? undefined
        : 'Obrigatório'
      : undefined,
  grExternaTexto: informacoes.ddr
    ? customTrim(informacoes.grExternaTexto)
      ? undefined
      : 'Obrigatório'
    : undefined,
  grExternaFileInput: informacoes.ddr
    ? customTrim(informacoes.grExternaFileInput)
      ? undefined
      : 'Obrigatório'
    : undefined,
  mercadoriaId: customTrim(informacoes?.mercadoriaId)
    ? undefined
    : 'Obrigatório',
  cliente: customTrim(informacoes?.cliente) ? undefined : 'Obrigatório',
  valorCarga: customTrim(informacoes?.valorCarga) ? undefined : 'Obrigatório',
  tempoViagem: customTrim(informacoes?.tempoViagem) ? undefined : 'Obrigatório',
  paisOrigem: customTrim(informacoes?.paisOrigem) ? undefined : 'Obrigatório',
  estadoOrigem: customTrim(informacoes?.estadoOrigem)
    ? undefined
    : 'Obrigatório',
  cidadeOrigem: customTrim(informacoes?.cidadeOrigem)
    ? undefined
    : 'Obrigatório',
  paisDestino: customTrim(informacoes?.paisDestino) ? undefined : 'Obrigatório',
  estadoDestino: customTrim(informacoes?.estadoDestino)
    ? undefined
    : 'Obrigatório',
  cidadeDestino: customTrim(informacoes?.cidadeDestino)
    ? undefined
    : 'Obrigatório'
})

function InfoSolicitacaoForm({
  classes,
  values,
  form,
  showError,
  cannotUpdate,
  ...props
}) {
  const { id } = useParams()
  const isNew = /new/.test(id)

  const [fetching, setFetching] = useState(false)
  const [alreadyFetched, setAlreadyFetched] = useState(false)
  const [mensagem, setMensagem] = useState('')

  const handleFileChange = (filePath, file) => {
    form.change(file, filePath)
  }

  const handleChangeRenovacao = async () => {
    try {
      const cpfNormalizado = values.cpfRenovacao
        ? values.cpfRenovacao.replace(/[^\d]/g, '')
        : null
      const placaNormalizada = values.placaRenovacao
        ? values.placaRenovacao.replace(/[^a-zA-Z0-9]/g, '')
        : null

      if (
        cpfNormalizado &&
        cpfNormalizado.length === 11 &&
        placaNormalizada &&
        placaNormalizada.length === 7 &&
        !alreadyFetched
      ) {
        setAlreadyFetched(true)
        setFetching(true)
        await getDados(cpfNormalizado, placaNormalizada)

        setFetching(false)
      }
    } catch (error) {
      setMensagem(error?.message || 'Falha de conexão com o servidor')

      form.batch(() => {
        form.change('renovado', false)
        form.change('ultimaLiberadaId', null)
        form.change('cpfRenovacao', null)
        form.change('placaRenovacao', null)
        form.change('motorista', {})
      })

      setFetching(false)
      setAlreadyFetched(false)
    }
  }

  const getDados = async (cpfRenovacao, placaRenovacao) => {
    const response = await solicitacoesEmbarcadorRepository.getDadosParaNenovacao(
      {
        where: {
          cpfRenovacao,
          placaRenovacao
        }
      }
    )

    if (!response.ok) {
      throw new Error(response.data?.error?.message)
    }

    const { motoristaKmm, lastSolicitacaoId } = response.data

    const motorista = motoristaKmm
    const veiculos = motorista.veiculos

    form.batch(() => {
      form.change('renovado', true)
      form.change('ultimaLiberadaId', lastSolicitacaoId)
      form.change('motorista', motorista)
      form.change('veiculos', veiculos)
    })
  }

  return (
    <div className={classes.root}>
      {fetching && <LinearProgress />}
      <Grid container spacing={4} justifyCOntent="center">
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Solicitação
          </Typography>
        </Grid>
        {isNew && (
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} lg={4}>
                <Field
                  hideEmpty
                  component={Select}
                  options={[
                    { label: 'Novo Cadastro', value: false },
                    { label: 'Renovação', value: true }
                  ]}
                  label="Tipo Solicitação"
                  name="renovado"
                />
              </Grid>
              {!!values.renovado && (
                <>
                  <Grid item xs={12} lg={4}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      format={parseCpf}
                      label="CPF"
                      name="cpfRenovacao"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              disabled={cannotUpdate}
                              onClick={handleChangeRenovacao}
                            >
                              <RefreshIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {values?.renovado && !values.cpfRenovacao && (
                      <Typography color="error" style={{ marginTop: '10px' }}>
                        Obrigatório encontrar motorista pelo CPF
                      </Typography>
                    )}
                  </Grid>
                  <OnChange name="cpfRenovacao">
                    {handleChangeRenovacao}
                  </OnChange>
                  <Grid item xs={12} lg={4}>
                    <Field
                      fullWidth
                      component={TextField}
                      parse={parsePlaca}
                      label="Placa"
                      name="placaRenovacao"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              disabled={cannotUpdate}
                              onClick={handleChangeRenovacao}
                            >
                              <RefreshIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {values?.renovado && !values.placaRenovacao && (
                      <Typography color="error" style={{ marginTop: '10px' }}>
                        Obrigatório informar a placa
                      </Typography>
                    )}
                  </Grid>
                  <OnChange name="placaRenovacao">
                    {handleChangeRenovacao}
                  </OnChange>
                </>
              )}
              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                label="GR"
                hideEmpty
                component={CustomAutocomplete}
                options={[
                  { label: 'Terceiro', value: 'TERCEIRO' },
                  { label: 'Agregado', value: 'AGREGADO' }
                ]}
                name="gr"
                showError={showError}
                disabled={cannotUpdate}
              />
            </Grid>
            {isNew ? (
              <Grid item xs={12} sm={12} lg={4}>
                <div hidden={values.gr !== 'AGREGADO'}>
                  <Field
                    accept=".jpg,.jpeg,.png,.pdf"
                    component={UploadField}
                    label="Contrato de Agregado"
                    name="contratoAgregadoInput"
                    onFileChange={filePath =>
                      handleFileChange(filePath, 'contratoAgregado')
                    }
                    showError={showError}
                  />
                </div>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={12} lg={4}>
                  <div hidden={values.gr !== 'AGREGADO'}>
                    <Field
                      solicitacaoId={values.id}
                      accept=".jpg,.jpeg,.png,.pdf"
                      component={DropzoneField}
                      label="Contrato de Agregado"
                      name="contratoAgregadoInput"
                      onFileChange={filePath =>
                        handleFileChange(filePath, 'contratoAgregado')
                      }
                      showError={showError}
                      disabled
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} lg={4}>
                  <div hidden={values.gr !== 'AGREGADO'}>
                    <CustomFileViewer
                      newTab
                      label="Contrato de Agregado"
                      filePath={values.contratoAgregado}
                      fileType="pdf"
                    />
                  </div>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                component={Checkbox}
                label="DDR"
                name="ddr"
                type="checkbox"
                disabled={cannotUpdate}
              />
            </Grid>
          </Grid>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                fullWidth
                component={TextField}
                label="GR Externa"
                name="grExternaTexto"
                showError={showError}
                disabled={cannotUpdate}
              />
            </Grid>
            {isNew ? (
              <Grid item xs={12} sm={12} lg={4}>
                <Field
                  accept=".jpg,.jpeg,.png,.pdf"
                  component={UploadField}
                  label="GR Externa"
                  name="grExternaFileInput"
                  onFileChange={filePath =>
                    handleFileChange(filePath, 'grExternaFile')
                  }
                  showError={showError}
                />
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={12} lg={4}>
                  <Field
                    solicitacaoId={values.id}
                    accept=".jpg,.jpeg,.png,.pdf"
                    component={DropzoneField}
                    label="GR Externa"
                    name="grExternaFileInput"
                    onFileChange={filePath =>
                      handleFileChange(filePath, 'grExternaFile')
                    }
                    showError={showError}
                    disabled={cannotUpdate}
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={4}>
                  <CustomFileViewer
                    newTab
                    label="GR Externa"
                    filePath={values.grExternaFile}
                    fileType="pdf"
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.marginTop} variant="h6" gutterBottom>
            Viagem
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                component={MercadoriaAutocomplete}
                label="Mercadoria"
                name="mercadoriaId"
                needDescription
                showError={showError}
                disabled={cannotUpdate || !isNew}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                component={TextField}
                label="Cliente"
                name="cliente"
                showError={showError}
                disabled={cannotUpdate || !isNew}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                component={TextField}
                InputProps={{
                  inputComponent: NumberFormatCustom
                }}
                label="Valor Carga"
                name="valorCarga"
                showError={showError}
                disabled={cannotUpdate || !isNew}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                component={TextField}
                label="Tempo"
                name="tempoViagem"
                showError={showError}
                disabled={cannotUpdate}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                fullWidth
                component={TextField}
                label="País Origem"
                name="paisOrigem"
                showError={showError}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                fullWidth
                hideEmpty
                component={Select}
                options={estadosOptions}
                label="Estado Origem"
                name="estadoOrigem"
                showError={showError}
                disabled={cannotUpdate}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                fullWidth
                provinciaId={values.estadoOrigem}
                component={MunicipioAutocomplete}
                label="Cidade Origem"
                name="cidadeOrigem"
                showError={showError}
                disabled={cannotUpdate}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                fullWidth
                component={TextField}
                label="País Destino"
                name="paisDestino"
                showError={showError}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                fullWidth
                hideEmpty
                component={Select}
                options={estadosOptions}
                label="Estado Destino"
                name="estadoDestino"
                showError={showError}
                disabled={cannotUpdate}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                fullWidth
                provinciaId={values.estadoDestino}
                component={MunicipioAutocomplete}
                label="Cidade Destino"
                name="cidadeDestino"
                showError={showError}
                disabled={cannotUpdate}
              />
            </Grid>
          </Grid>
        </Grid>
        <ObservacaoField
          value={values.observacaoInformacoesGerais}
          title="Observações Informações gerais"
          placeholder="Escreva aqui observações sobre as informações gerais"
          name="novaObservacaoInformacoesGerais"
          disabled={cannotUpdate}
        />
      </Grid>
      <Snackbar
        message={mensagem}
        autoHideDuration={10000}
        onClose={() => setMensagem('')}
      />
    </div>
  )
}

export default withStyles(styles)(InfoSolicitacaoForm)
